import { Component, Input, Output, EventEmitter, HostListener, ElementRef, ViewChild, ViewChildren, OnInit, OnDestroy } from '@angular/core';

import { Size } from 'app/shared/models/size';
import {ISubscription} from "rxjs/Subscription";
import {CommonService} from "../services/common.service";

export enum ResizeDirection {
    BottomRight = 0,
    Vertical = 1,
    Horizontal = 2
}

@Component({
    selector: 'resize-glyph',
    templateUrl: './resize-glyph.component.html',
    styleUrls: ['resize-glyph.component.css']
})
export class ResizeGlyphComponent implements OnInit, OnDestroy {
    constructor(private readonly elementRef: ElementRef, private readonly commonService: CommonService) {
        this.resizeDirection = ResizeDirection.BottomRight;
        this.resizeBy = new EventEmitter<Size>();
        // this.cssClass = '';
    }

    private direction: ResizeDirection;
    @Input('direction')
    set resizeDirection(value: ResizeDirection) {
        this.direction = value;
        this.cssClass = '';
        let cssClass = 'resize-glyph ';
        switch(this.direction) {
            case ResizeDirection.BottomRight:
            default:
                cssClass += 'resize-glyph-bottom-right';
                this.cursor = 'nwse-resize';
                break;
            case ResizeDirection.Vertical:
                cssClass += 'resize-glyph-vertical';
                this.cursor = 'ns-resize';
                break;
            case ResizeDirection.Horizontal:
                cssClass += 'resize-glyph-horizontal';
                this.cursor = 'ew-resize';
                break;
        }
        this.cssClass += cssClass;
    }

    @Input()
    private cssClassIn: string[];

    @Output()
    private readonly resizeBy: EventEmitter<Size>;

    @ViewChild('glyph')
    private glyph: ElementRef;

    @ViewChildren('glyphChild')
    private glyphChildren: ElementRef[];

    private cssClass: string;

    private mouseDown: boolean;

    private cursor: string;

    private lastX: number;

    private lastY: number;

    private subscriptionMouseMove: ISubscription;

    ngOnInit(){
        this.cssClassIn && this.cssClassIn.length ? this.cssClass += ` ${this.cssClassIn.join(' ')}` : null;
        // this.subscriptionMouseMove = this.commonService.mouseMoveCurrent.subscribe(res => { console.log(res, 'subscriptionMouseMove'); res ? this.onMouseMove(res) : null} );
    }

    ngOnDestroy(){
        // this.subscriptionMouseMove.unsubscribe();
    }


    @HostListener('window:mousedown', ['$event'])
    private onMouseDown = (event: MouseEvent): void => {
        if (event.button !== 0 ||
        (event.target !== this.glyph.nativeElement &&
            this.glyphChildren.find(e => event.target === e.nativeElement) == null))
            return;

        this.mouseDown = true;
        this.lastX = event.screenX;
        this.lastY = event.screenY;
    }

    @HostListener('window:mouseup', ['$event'])
    private onMouseUp = (event: MouseEvent): void => {
        if (event.button === 0)
            this.mouseDown = false;
    }

    @HostListener('window:mousemove', ['$event'])
    private onMouseMove = (event: MouseEvent): void => {
        if (!this.mouseDown)
            return;

        const movementX = event.screenX - this.lastX;
        const movementY = event.screenY - this.lastY;
        this.lastX = event.screenX;
        this.lastY = event.screenY;
        if (movementX !== 0 || movementY !== 0)
            this.resizeBy.emit(new Size(movementX, movementY));
    }
}



// WEBPACK FOOTER //
// ./src/app/resize-glyph/resize-glyph.component.ts